// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3nSVz","name":"Header_name__ECYsw","birthday":"Header_birthday__RDsET","skeleton":"Header_skeleton__mvs6z"};